import { CheckCircle } from 'lucide-react';

interface WhyInventiveHQProps {
  productName?: string;
  className?: string;
}

const benefits = [
  {
    title: 'Authorized Partner',
    description: 'We work with leading vendors to provide genuine, fully licensed software solutions.',
  },
  {
    title: 'Expert Deployment',
    description: 'Our team helps configure and deploy solutions tailored to your needs.',
  },
  {
    title: 'Ongoing Support',
    description: 'Dedicated account management and technical support when you need it.',
  },
  {
    title: 'Volume Licensing',
    description: 'Flexible licensing options tailored to your organization\'s size and needs.',
  },
];

export default function WhyInventiveHQ({ productName, className = '' }: WhyInventiveHQProps) {
  const title = productName
    ? `Why Get ${productName} Through Inventive HQ?`
    : 'Why Choose Inventive HQ?';

  return (
    <section className={`py-8 sm:py-12 bg-white dark:bg-gray-800 border-b ${className}`}>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-5 sm:p-8 lg:p-10">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-gray-100 mb-5 sm:mb-6 text-center">
            {title}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
            {benefits.map((benefit) => (
              <div
                key={benefit.title}
                className="flex items-start gap-3 sm:gap-4 bg-white/60 dark:bg-gray-800/60 rounded-xl p-4 sm:p-5"
              >
                <div className="w-8 h-8 sm:w-9 sm:h-9 bg-green-100 dark:bg-green-900/40 rounded-lg flex items-center justify-center flex-shrink-0">
                  <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6 text-green-600 dark:text-green-400" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-gray-900 dark:text-gray-100 text-base">{benefit.title}</h3>
                  <p className="text-sm sm:text-base text-gray-600 dark:text-gray-400 mt-1.5">{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
